import { render } from "./LeftSideBar.vue?vue&type=template&id=0b2cdcb4&scoped=true&ts=true"
import script from "./LeftSideBar.vue?vue&type=script&lang=ts"
export * from "./LeftSideBar.vue?vue&type=script&lang=ts"

import "./LeftSideBar.vue?vue&type=style&index=0&id=0b2cdcb4&lang=css"
import "./LeftSideBar.vue?vue&type=style&index=1&id=0b2cdcb4&lang=less&scoped=true"

import exportComponent from "E:\\bjft\\bjft-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2cdcb4"]])

export default __exports__